import {BaseSingleInputComponent, BaseSingleInputComponentController} from '../baseSingleInput.component';

export interface IPercentOrDollarInputBindings {
    percentOfModelBinding: string;
}

export class PercentOrDollarInputComponent extends BaseSingleInputComponent {
    protected getController(): typeof BaseSingleInputComponentController {
        return PercentOrDollarInputComponentController;
    }

    protected getTemplateUrl(): string {
        return './modules/quoteWizard/components/singleInputComponents/percentOrDollar/percentOrDollarInput.view.html';
    }

    protected getBindings(): any {
        return {
            percentOfModelBinding: '='
        };
    }
}

// internal interface between the component and the controller -- this is the controller's API
interface IPercentOrDollarInputComponentController extends IPercentOrDollarInputBindings {
    percentAmount: number;

    goNext(): void;

    goBack(): void;

    onPercentChange(): void;

    onDollarAmountChange(): void;
}

// tslint:disable-next-line:max-classes-per-file
export class PercentOrDollarInputComponentController extends BaseSingleInputComponentController implements IPercentOrDollarInputComponentController {
    public percentOfModelBinding: string;
    public percentAmount: number;

    public modelValue: number;
    public percentOfValue: number;

    public static $inject = ['$scope', 'ValidationService', '$parse', '$document'];

    constructor($scope: any, validationService: any, private $parse?: any, private $document?: ng.IDocumentService) {
        super($scope, validationService);
    }

    protected activate() {
        super.activate();
        this.modelValue = this.convertToNumber(this.modelBinding);
        this.percentOfValue = this.convertToNumber(this.percentOfModelBinding);
        this.percentAmount = this.roundToTwoPlaces((this.modelValue / this.percentOfValue * 100));
        // set up auto numeric
        const element: any = this.$document.find('#percentOfLabelContainer');
        const options = {aSign: '$', mDec: 0};
        element.autoNumeric('init', options);
        element.autoNumeric('set', this.percentOfValue);
    }

    public onPercentChange(): void {
        if (this.percentAmount >= 0) {
            this.modelValue = Math.round(this.percentOfValue * (this.percentAmount / 100));
            this.modelBinding = this.modelValue.toString();
        }
    }

    public onDollarAmountChange(): void {
        if (this.modelValue >= 0) {
            this.percentAmount = this.roundToTwoPlaces((this.modelValue / this.percentOfValue * 100));
            this.modelBinding = this.modelValue.toString();
        }
    }

    private convertToNumber(value: string): number {
        const newValue = parseFloat(value);
        if (!isNaN(newValue) && isFinite(newValue)) {
            return newValue;
        }
        return undefined;
    }

    private roundToTwoPlaces(value: number): number {
        return this.convertToNumber(value.toFixed(2));
    }
}
